export default __webpack_public_path__ + "static/media/miguel-lopes-23.8002d039.jpg";